import { FC } from 'react';
import FullCalendar from '@fullcalendar/react';
import { OptionsInput } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import coreCSS from '@fullcalendar/core/main.css?raw';
import dayGridCSS from '@fullcalendar/daygrid/main.css?raw';
import styled from 'styled-components';

export { dayGridPlugin };

const StyledCalendar = styled.div`
  ${coreCSS}
  ${dayGridCSS}
  .fc {
    th,
    td,
    thead,
    tbody,
    .fc-divider,
    .fc-row,
    .fc-content,
    .fc-popover,
    .fc-list-view,
    .fc-list-heading td {
      border-color: ${({ theme }) => theme.vars.newColor.lightGS1};
    }
    td.fc-today {
      background: ${({ theme }) => theme.vars.newColor.blue4};
    }
    th {
      padding: 5px;
    }
    .fc-dayGrid-view .fc-week-number,
    .fc-dayGrid-view .fc-day-number {
      padding: 5px;
    }
    .fc-other-month {
      background: ${({ theme }) => theme.vars.newColor.lightGS2};
    }
    .fc-button {
      border-radius: 0;
    }
    .fc-button-primary {
      color: ${({ theme }) => theme.vars.newColor.darkGS2};
      background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
      border-color: ${({ theme }) => theme.vars.newColor.lightGS1};
      :disabled {
        color: ${({ theme }) => theme.vars.newColor.darkGS2};
        background-color: ${({ theme }) => theme.vars.newColor.lightGS2};
        border-color: ${({ theme }) => theme.vars.newColor.lightGS2};
      }
      :not(:disabled):active,
      :not(:disabled).fc-button-active {
        color: ${({ theme }) => theme.vars.newColor.darkGS2};
        background-color: ${({ theme }) => theme.vars.newColor.lightGS1};
        border-color: ${({ theme }) => theme.vars.newColor.lightGS1};
      }
    }
    .fc-event,
    .fc-event-dot {
      background-color: ${({ theme }) => theme.vars.newColor.blue1};
    }
    .fc-event {
      border-color: ${({ theme }) => theme.vars.newColor.blue1};
      border-radius: 0;
    }
    .fc-day-grid-event {
      margin: 3px 3px 0;
      padding: 3px 5px;
    }
    .fc-prev-button,
    .fc-next-button {
      background: none;
      border: 0;
    }
  }
`;

export const Calendar: FC<OptionsInput> = props => (
  <StyledCalendar>
    <FullCalendar {...props} />
  </StyledCalendar>
);
